import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'src/app/store';
import { LinkProps } from 'src/commons/utils/types';

// Define a type for the slice state
interface FooterState {
  copyright: string;
  links: Array<LinkProps>;
}

// Define the initial state using that type
export const footerInitialState: FooterState = {
  copyright: '',
  links: [],
};

export const footerSlice = createSlice({
  name: 'footer',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState: footerInitialState,
  reducers: {
    initFooterState: (state, action: PayloadAction<FooterState>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { initFooterState } = footerSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectFooterState = (state: RootState): FooterState =>
  state.footer;

export default footerSlice.reducer;
